<template>
  <b-container fluid class="start-stop-fab">
    <b-row>
      <b-col>
        <b-button v-if="processingCommand" class="start-stop-btn processing-btn" disabled="true"></b-button>
        <b-button v-else-if="vehicle.poweredOn" class="start-stop-btn unlocked-btn" @click="sendCommand('STOP', vehicle.id)"></b-button>
        <b-button v-else class="start-stop-btn locked-btn" @click="sendCommand('START', vehicle.id)"></b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

  import {firebaseAuth} from "@/firebase";
  import axios from "axios";

  export default {
    name: "StartStopFab",
    props: {
      vehicle: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        processingCommand: false,
      }
    },
    methods: {
      startScooter(id) {
        return this.sendCommand("START", id);
      },
      stopScooter(id) {
        return this.sendCommand("STOP", id);
      },
      async sendCommand(command, vehicleId) {
        this.setProcessing(true);
        let authToken = await firebaseAuth.currentUser.getIdToken();
        try {
          await axios.post(
              `https://europe-west3-coscooter-eu-staging.cloudfunctions.net/send-commands?apiKey=${authToken}`,
              { command, vehicleId }
          );
        } catch (e) {
          this.setProcessing(false);
          return;
        }
        this.setProcessing(false);
      },
      setProcessing(isProcessing) {
        this.processingCommand = isProcessing;
        this.$emit('startStopProcessingChanged', { isProcessing, vehicleId: this.vehicle.id })
      }
    }
  }
</script>

<style scoped>
  .start-stop-fab {
    position: fixed;
    width: 100% !important;
    height: 70px;
    bottom: 135px;
    z-index: 100;
  }
  .start-stop-btn {
    height:70px;
    width:70px;
    display:inline-block;
    border-radius: 50%;
    border:none;
    background-position-x: center;
    background-position-y: center;
    box-shadow: 3px 4px 16px rgba(0,0,0,0.2);
  }
  .start-stop-btn:focus {
    box-shadow: 3px 4px 16px rgba(0,0,0,0.2);
  }
  .processing-btn {
    background:url('../assets/images/scooter-processing-btn-2x.png') left center no-repeat;
    background-size: cover;
  }
  .unlocked-btn {
    background:url('../assets/images/scooter-unlocked-btn-2x.png') left center no-repeat;
    background-size: cover;
  }
  .locked-btn {
    background:url('../assets/images/scooter-locked-btn-2x.png') left center no-repeat;
    background-size: cover;
  }
</style>
